import styled from "styled-components";

const ButtonsContainer = styled.div`
  position: relative;
  width: 99.5%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 25px;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

export default ButtonsContainer;
